import { SharedResourceBlocksRequestData } from '../../../../api';
import { popcount } from '../../../../utils/maskUtils';

/**
 * Drops scheduler blocks that block nothing before an unavailability is saved.
 *
 * This matters more than it looks. The backend treats an unavailability that carries ANY
 * scheduler_configs entry as "the scheduler will handle this via its masks" and skips it when
 * closing scheduler-managed pages
 * (api `private_session_availability_calculator._check_plain_unavailabilities_for_scheduler_page`).
 * Only an unavailability with no scheduler blocks at all closes those pages outright — which is
 * what spec §4 means by using a plain unavailability for "סגירת המתחם".
 *
 * The form seeds one all-zero entry per config so the resource grid has something to render, so
 * without this an admin closing the whole studio would submit zero-mask blocks, the backend would
 * skip the unavailability, and the day would stay bookable.
 */
export const stripEmptySchedulerBlocks = (
  blocks: SharedResourceBlocksRequestData | undefined,
): SharedResourceBlocksRequestData | undefined => {
  if (!blocks?.scheduler_configs?.length) {
    return blocks;
  }
  return {
    ...blocks,
    scheduler_configs: blocks.scheduler_configs.filter((block) => popcount(block.blocked_mask) > 0),
  };
};
